import { render, staticRenderFns } from "./AussieTimeRegistrationRenewal.vue?vue&type=template&id=6a63e907"
import script from "./AussieTimeRegistrationRenewal.vue?vue&type=script&lang=ts"
export * from "./AussieTimeRegistrationRenewal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports